import React from "react";
import ReactDOM from "react-dom/client";
import App from "./components/App";

// ReactDOM.render(
//   <h1>Hello React!</h1>,
//   document.getElementById('root')
// );

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App></App>);
/*
    New App().render();
*/
